/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCRightIcon16Light } from './ArrowCRightIcon16Light';
import { ArrowCRightIcon16Regular } from './ArrowCRightIcon16Regular';
import { ArrowCRightIcon16Solid } from './ArrowCRightIcon16Solid';
import { ArrowCRightIcon20Light } from './ArrowCRightIcon20Light';
import { ArrowCRightIcon20Regular } from './ArrowCRightIcon20Regular';
import { ArrowCRightIcon20Solid } from './ArrowCRightIcon20Solid';
import { ArrowCRightIcon24Regular } from './ArrowCRightIcon24Regular';
import { ArrowCRightIcon24Solid } from './ArrowCRightIcon24Solid';
import { ArrowCRightIcon32Regular } from './ArrowCRightIcon32Regular';
import { ArrowCRightIcon64Regular } from './ArrowCRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowCRightIcon16Light,
        regular: ArrowCRightIcon16Regular,
        solid: ArrowCRightIcon16Solid,
    },
    20: {
        light: ArrowCRightIcon20Light,
        regular: ArrowCRightIcon20Regular,
        solid: ArrowCRightIcon20Solid,
    },
    24: {
        regular: ArrowCRightIcon24Regular,
        solid: ArrowCRightIcon24Solid,
    },
    32: {
        regular: ArrowCRightIcon32Regular,
    },
    64: {
        regular: ArrowCRightIcon64Regular,
    },
};
export var ArrowCRightIcon = forwardRef('ArrowCRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
